import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import ProtectedRoute from './routes/ProtectedRoute';
import LoginPage from './pages/Auth/Login';
import Layout from './components/layout/Layout';
import AdminDashboard from './pages/AdminDashboard';
import UserDetail from './pages/UserDetail';
import BetHistoryDashboard from './pages/BetHistoryDashboard';
import PaymentMethods from './pages/PaymentMethods';
import Settings from './pages/Settings';
import Users from './pages/Users';
import Wallet from './pages/WalletUpdate';
import AdminAccount from './pages/AdminAccount';
import ManualWithdrawal from './pages/ManualWithdrawal';
import ManualDeposit from './pages/ManualDeposit';
import Level from './pages/Level';
import DepositBonus from './pages/DepositBonus';
import DepositCommissionLevel from './pages/LevelCommission/DepositCommissionLevel';
import Collaborators from './pages/Collaborators';
import Wingo from './pages/Wingo';
import PendingIssues from './pages/Support/PendingIssues';
import ResolvedIssues from './pages/Support/ResolvedIssues';
import GiftCode from './pages/GiftCode';
import CollaboratorsProfile from './pages/CollaboratorsProfile';
import BetCommissionLevel from './pages/LevelCommission/BetCommissionLevel';
import Analytics from './pages/Analytics/Analytics';
import BonusAndPaneltyHistory from './pages/BonusAndPaneltyHistory';
import BonusAndPanelty from './pages/BonusAndPanelty';



function App() {

  return (
    // <BrowserRouter>
    //   <Routes>
    //     <Route path="/login" element={<LoginPage />} />
    //     <Route element={<ProtectedRoutes />}>
    //       <Route path="/" element={<Layout />}>
    //         <Route index element={<AdminDashboard />} />
    //         <Route path="withdraw" element={<Withdraw />} />
    //         <Route path="users" element={<Users />} />
    //         <Route path="users-details/:id" element={<UserDetail />} />
    //         <Route path="bet-history-dashboard" element={<BetHistoryDashboard />} />
    //         <Route path="settings" element={<Settings />} />
    //         <Route path="payment-methods" element={<PaymentMethods />} />
    //         <Route path="level" element={<Level />} />
    //         <Route path="stateList" element={<StateList />} />
    //         <Route path="countryList" element={<CountryList />} />
    //         <Route path="depositBonus" element={<DepositBonus />} />
    //         <Route path="/subadmin" element={<SubAdmin />} />
    //         <Route path="/subadminuser" element={<SubAdminUser />} />
    //         <Route path="DepositCommissionLevel" element={<DepositCommissionLevel />} />
    //         <Route path="BetCommissionLevel" element={<BetCommissionLevel />} />
    //         <Route path="AdminAccount" element={<AdminAccount />} />
    //         <Route path="manual-withdrawal" element={<ManualWithdrawal />} />
    //         <Route path="manual-deposit" element={<ManualDeposit />} />
    //         <Route path="deposit" element={<Deposit />} />
    //         <Route path="games" element={<Game/>} />
    //         <Route path="win-settings" element={<WinSettings/>} />
    //         <Route path="house" element={<House />} />
    //         <Route path="wallet" element={<Wallet />} />
    //         <Route path="history" element={<History />} />
    //         <Route path="seo-manager" element={<SEO/>} />
    //         <Route path="affiliate" element={<Referal/>} />
    //         <Route path="sitesetting" element={<SiteSettings/>} />
    //         <Route path="notification-settings" element={<NotificationSettings/>} />
    //       </Route>
    //     </Route>
    //   </Routes>
    // </BrowserRouter>
    <Routes>
      {/* Public */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected layout */}
      <Route
        path="*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route index element={<AdminDashboard />} />
                <Route path='/analytics' element={<Analytics />} />
                <Route path="/users" element={<Users />} />
                <Route path="/users/profile/:id" element={<UserDetail />} />
                <Route path="/api-management" element={<BetHistoryDashboard />} />
                <Route path="/settings/general" element={<Settings />} />
                <Route path="/settings/payments" element={<PaymentMethods />} />
                <Route path="/bonus-and-panelty" element={<BonusAndPanelty />} />
                <Route path="/bonus-and-panelty-history" element={<BonusAndPaneltyHistory />} />
                <Route path='/admin' element={<AdminAccount />} />

                <Route path="/recharge-list" element={<ManualDeposit />} />
                <Route path="/approved-recharges" element={<ManualDeposit />} />


                <Route path="/withdrawal-list" element={<ManualWithdrawal />} />
                <Route path="/approved-withdrawals" element={<ManualWithdrawal />} />

                <Route path="/settings/level" element={<Level />} />
                <Route path="/settings/deposit/bonus" element={<DepositBonus />} />

                <Route path="/settings/deposit/levels" element={<DepositCommissionLevel />} />
                <Route path="/settings/bet/levels" element={<BetCommissionLevel />} />

                <Route path="/collaborators" element={<Collaborators />} />
                <Route path="/collaborators/profile/:id" element={<CollaboratorsProfile />} />

                <Route path="/wingo-management" element={<Wingo />} />

                {/* support */}
                <Route path="/pending-issues" element={<PendingIssues />} />
                <Route path="/resolved-issues" element={<ResolvedIssues />} />

                <Route path="/gift-codes" element={<GiftCode />} />


              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

export default App;
